import React, { useEffect } from "react";
import {
  SearchLayout,
  MapView,
  MapBanner,
  PubMore,
  MapPub,
} from "./Components";
import { useUI } from "../NewSearch/Hook/UIContext";
import { useStore } from "../NewSearch/Hook/StoreContext";
import { useSearchContext } from "../NewSearch/Hook/SearchContext";

const StoreListContent: React.FC = () => {
  const {
    showFilter,
    showSearch,
    showLocationFilter,
    setShowLocationFilter,
    showStoreList,
  } = useUI();
  const { selectedStore } = useStore();
  const { mapCenter } = useSearchContext();

  return (
    <>
      <SearchLayout
        showFilter={showFilter}
        showLocationFilter={showLocationFilter}
        setShowLocationFilter={setShowLocationFilter}
      >
        {!showStoreList && mapCenter && <MapView />}
        {!showSearch && <MapBanner />}
      </SearchLayout>
      {showStoreList && selectedStore && <PubMore cafe={selectedStore} />}
      {!showStoreList && selectedStore && <MapPub cafe={selectedStore} />}
    </>
  );
};

export default StoreListContent;
